
import { computed, defineComponent, PropType, ref, toRefs } from 'vue';
import { CONTEXT_TYPES } from '@dh-io-cscs/user-context-manager/dist/common/constants';
import { EmhConfig, Product } from '@dh-io-emh/search-result-store';
import { IOutputs } from 'fcis-widget/dist/types/interfaces/IOneCalcResponseV2';
import { TFunction } from 'i18next';
import { useFcisWidget } from '../composables/finance.composable';
import { getHostReadyClass } from '../utils/webcomponent';
import AdditionalData from './AdditionalData.vue';

export default defineComponent({
  name: 'EmhMonthlyPriceInformation',

  components: {
    AdditionalData,
  },

  props: {
    product: {
      type: Object as PropType<Product>,
      required: false,
      default: undefined,
    },
    country: {
      type: String,
      required: true,
    },
    language: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    postCode: {
      type: String,
      required: true,
    },
    customerType: {
      type: String as PropType<CONTEXT_TYPES>,
      required: false,
      default: undefined,
    },
    emhConfig: {
      type: Object as PropType<EmhConfig>,
      required: true,
    },
    t: {
      type: Function as PropType<TFunction>,
      required: true,
    },
  },

  emits: ['fcis-quote', 'fcis-error', 'fcis-popup-open', 'fcis-popup-toggle'],

  setup(props, { emit }) {
    const { product, customerType, emhConfig, postCode, locale } = toRefs(props);
    const fcisWidgetEl = ref<HTMLFcisWidgetElement>();
    const viewportEntered = ref(false);
    const fcisReady = ref(false);

    const onFcisQuote = (event: CustomEvent<IOutputs>) => {
      fcisReady.value = true;
      emit('fcis-quote', event);
    };
    const onFcisError = (event: CustomEvent<any>) => emit('fcis-error', event);
    const onFcisPopupToggle = ({ detail: { state } }: CustomEvent<{ state: boolean }>) =>
      emit('fcis-popup-toggle', state);

    const hostCssClass = computed(() => getHostReadyClass(`emh-stage-campaign-item__monthly-price`, fcisReady.value));

    const { environment } = useFcisWidget({
      fcisWidgetEl,
      product,
      customerType,
      emhConfig: emhConfig.value,
      postCode,
      locale,
    });

    return {
      hostCssClass,
      fcisWidgetEl,
      viewportEntered,
      environment,
      onFcisQuote,
      onFcisError,
      onFcisPopupToggle,
    };
  },
});
